export default function formatCountryCodeOptions(countries) {
  if (!countries || countries.length === 0) {
    return []
  }

  const uniqueCodes = [
    ...new Set(
      countries
        .filter((country) => country?.countryCode != null)
        .map((country) => country.countryCode)
    ),
  ]

  return uniqueCodes
    .sort((a, b) => a - b)
    .map((code) => ({
      label: `+${code}`,
      value: `+${code}`,
    }))
}
